import axios from '@/lib/AxApi';

export default {
    async selectHistoryRow(params)
    {
        try
        {
            params.isChild = 0;
            const response = await axios.get('/ChildHistory/selectRow', {
                params,
            });
            return response.data;
        }
        catch (e)
        {
            throw ({
                error: true,
                notice: axios.errorHandler(e),
            });
        }
    },
    async selectRow(params)
    {
        try
        {
            params.isChild = 0;
            const response = await axios.get('/Child/selectRow', {
                params,
            });
            return response.data;
        }
        catch (e)
        {
            throw ({
                error: true,
                notice: axios.errorHandler(e),
            });
        }
    },
    async selectSingleRow(params)
    {
        try
        {
            params.isChild = 0;
            const response = await axios.get('/Child/selectSingleRow', {
                params,
            });
            return response.data;
        }
        catch (e)
        {
            throw ({
                error: true,
                notice: axios.errorHandler(e),
            });
        }
    },
    async submitData(params)
    {
        try
        {
            params.isChild = 0;
            let func = 'insertRow';
            if (typeof params.id !== 'undefined' && params.id !== '')
            {
                func = 'updateRow';
            }

            const response = await axios.post(`/Child/${func}`, params);
            return response.data;
        }
        catch (e)
        {
            throw ({
                error: true,
                notice: axios.errorHandler(e),
            });
        }
    },
    async deleteRow(params)
    {
        try
        {
            const response = await axios.post('/Child/deleteRow', params);
            return response.data;
        }
        catch (e)
        {
            throw ({
                error: true,
                notice: axios.errorHandler(e),
            });
        }
    },
    async printToPdf(params)
    {
        window.open(`/Child/printToPdf?childId=${params.childId}`);
    },
    async printPreviouseToPdf(params)
    {
        window.open(`/Child/printPreviouseToPdf?childId=${params.childId}&childHistoryId=${params.childHistoryId}`);
    },
};
